<footer class="ac-footer">
  <div class="ac-container ac-footer__grid">
    <div class="ac-footer__brand">
      <strong class="ac-footer__name">{{ content.name }}</strong>
      <p class="ac-footer__tagline">{{ content.tagline }}</p>
      <p class="ac-footer__note">{{ content.description }}</p>
    </div>

    <div class="ac-footer__col">
      <h3>Modules</h3>
      @for (mod of content.modules; track mod.id) {
      <a [routerLink]="mod.route">{{ mod.name }}</a>
      }
    </div>

    <div class="ac-footer__col">
      <h3>Cosmos stack</h3>
      @for (item of content.stack.items; track item.label) {
      <a [href]="item.href" target="_blank" rel="noopener noreferrer"
        >{{ item.label }}</a
      >
      } @for (item of content.ecosystem; track item.label) {
      <a [href]="item.href" target="_blank" rel="noopener noreferrer"
        >{{ item.label }}</a
      >
      }
    </div>

    <div class="ac-footer__col">
      <h3>Resources</h3>
      <a
        [href]="content.githubFrontend"
        target="_blank"
        rel="noopener noreferrer"
        >Frontend repo</a
      >
      <a
        [href]="content.githubContracts"
        target="_blank"
        rel="noopener noreferrer"
        >Contracts repo</a
      >
      <a [href]="content.interinnlUrl">InterINNL hub</a>
      <a routerLink="/contact">Contact</a>
      <a
        [href]="content.interchouetteUrl"
        target="_blank"
        rel="noopener noreferrer"
        >Interchouette</a
      >
    </div>
  </div>

  <div class="ac-container ac-footer__bottom">
    <p>© {{ content.copyrightYear }} AquaChain · InterINNL hackathon project</p>
  </div>
</footer>
